<template>
  <app-top-tabs
      :tabs="[
        {id: 'account', text: '账号信息'},
        // {id: 'setMeal', text: '套餐额度'},
      ]"
  >
    <template #account>
      <div class="personal-center">
        <div class="content">
          <gj-area-title>基本信息</gj-area-title>
          <div class="content-detail">
            <div style="padding-top: 0">
              <span class="personal-label">用户名</span>
              <span class="personal-value">{{personalInfo.userName}}</span>
              <template v-if="personalInfo.isMain">
                <div class="main-account-styl">
                  <div style="align-items: center; display: grid">
                    <img src="./img/main-account.png"/>
                  </div>
                </div>
              </template>
            </div>
            <div class="content-name--hover">
              <span class="personal-label">真实姓名</span>
              <template v-if="flag.realNameFlag">
                <gj-input width="140px" v-model="editRealName"></gj-input>
                <gj-button :loading="loading.name" type="primary" style="margin-left: 8px" @click="saveName">保存</gj-button>
              </template>
              <template v-else>
                <span class="personal-value">{{personalInfo.realName}}</span>
                <i class="el-icon-edit name-edit" @click="flag.realNameFlag = !flag.realNameFlag"></i>
              </template>
            </div>
            <div >
              <span class="personal-label">角色</span>
              <span class="personal-value">
                <span style="margin-right: 10px" v-for="(item, index) in personalInfo.roleList" :key="index">
                  {{item}}
                </span>
              </span>
            </div>
            <div>
              <span class="personal-label">手机号码</span>
              <span class="personal-value">{{personalInfo.phone}}<gj-button @click="validatorPhone" type="text" style="padding: 0; margin-left: 8px">更换</gj-button></span>
            </div>
            <div class="content-email--hover">
              <span class="personal-label">邮件账号</span>
              <template v-if="flag.emailFlag">
                <gj-input width="140px" v-model="editEmail"></gj-input>
                <gj-button :loading="loading.email" type="primary" style="margin-left: 8px"  @click="saveEmail" >保存</gj-button>
              </template>
              <template v-else>
                <span class="personal-value">{{personalInfo.email || '-'}}</span>
                <i class="el-icon-edit email-edit" @click="flag.emailFlag = !flag.emailFlag"></i>
              </template>
            </div>
            <div>
              <span class="personal-label">密码</span>
              <span class="personal-value"><gj-button @click="replacePwd" type="text" style="padding: 0;">更换</gj-button></span>
            </div>
            <template v-if="isMeaningful(boundWx)">
              <div style="display: flex; padding-top: 0;">
                <span class="personal-label" style="margin-top: 10px;">绑定微信</span>
                <div class="personal-value" style="display: inline-block;">
                  <template v-if="!boundWx">
                    <div v-if="qrCodeExpired"
                         v-loading="qrCodeLoading"
                         class="expired-qrcode">
                      <div class="expired-qrcode-tip">二维码已过期</div>
                      <gj-button
                          type="primary"
                          @click="refreshQrCode"
                      >请刷新二维码</gj-button>
                    </div>
                    <div v-loading="qrCodeLoading && !qrCodeExpired">
                      <gj-image
                          :src="qrCodeSrc"
                          size="150"
                      ></gj-image>
                    </div>
                    <div>
                      <div class="unbind-title">
                        <gj-tag
                            color="#999"
                            shape="rectangle"
                            type="dark"
                            style="padding-top: 1px;"
                        >未绑定</gj-tag>
                        <span style="margin-left: 8px; color: #333;">微信扫一扫绑定</span>
                      </div>
                      <div style="display: flex;">
                        <gj-icon class="el-icon-caret-top" style="font-size: 20px; margin-right: 3px;"></gj-icon>
                        <span style="color: #8e8e8e;">绑定后，可用微信查看店铺看板、排行榜、海卖助手</span>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div :style="{margin: personalInfo.wxHeadImageAddress ? '10px 0 8px' : null}">
                      <gj-image
                          :src="personalInfo.wxHeadImageAddress"
                          size="150"
                      ></gj-image>
                    </div>
                    <div>
                      <div class="unbind-title">
                        <gj-tag
                            color="#34c160"
                            shape="rectangle"
                            type="dark"
                            style="padding-top: 1px;"
                        >已绑定微信</gj-tag>
                        <span style="margin-left: 8px;"><gj-link @click="unbindWx">解除绑定</gj-link></span>
                      </div>
                      <div style="display: flex;">
                        <gj-icon class="el-icon-caret-top" style="font-size: 20px; margin-right: 3px;"></gj-icon>
                        <span style="color: #8e8e8e;">现在可用微信查看店铺看板、排行榜、海卖助手</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>

         <div style="margin-top: 30px;padding-bottom: 50px;" v-if="$permission('userCompany:view')" v-loading="loading.company">
            <gj-area-title>
            公司信息
            <span @click="handEdit" v-if="$permission('userCompany:saveOrUpdate')">
              <gj-icon iconfont="iconbianji" class="edit-company-info_icon" ></gj-icon>
            </span>
          </gj-area-title>
          <el-form inline :model="companyForms" ref="performs">
            <el-form-item label="公司名称">
              <gj-input 
              :disabled="persionDisabled"
              maxlength="50"
              placeholder="公司名称" 
              v-model="companyForms.companyName" 
              width="260px"></gj-input>
            </el-form-item>
            <div class="edit-company-info_item" v-for="(item, index) in companyForms.persionInfo" :key="index">
              <div class="edit-company-info_item-inner">
                <el-form-item label="收货人姓名" 
                :prop="'persionInfo.' + index + '.consignee'"
                :rules="[{required: true, message: '请输入姓名', trigger: ['change', 'blur']}]" >
                  <gj-input placeholder="姓名" maxlength="50" v-model="item.consignee" width="120px" :disabled="persionDisabled"></gj-input>
                </el-form-item>
                <el-form-item 
                :prop="'persionInfo.' + index + '.consigneeTel'"
                label="电话" 
                :rules="[{required: true, message: '请输入电话', trigger: ['change', 'blur']}]">
                  <gj-input   placeholder="电话" maxlength="30" v-model="item.consigneeTel" width="120px" :disabled="persionDisabled"></gj-input>
                </el-form-item>
                <el-form-item 
                :prop="'persionInfo.' + index + '.consigneeAddress'"
                label="收货地址" 
                :rules="[{required: true, message: '请输入收货地址', trigger: ['change', 'blur']}]" >
                  <gj-input maxlength="50"  placeholder="收货地址" v-model="item.consigneeAddress" width="180px" :disabled="persionDisabled"></gj-input>
                </el-form-item>
                <span @click="addPersion" v-if="index === 0 && !persionDisabled">
                  <gj-icon iconfont="iconzengjia" class="edit-company-info_add"></gj-icon>
                </span>
                <span v-if="index > 0 && !persionDisabled" @click="reducePersion(index)">
                  <gj-icon iconfont="iconjianshao" class="edit-company-info_add"></gj-icon>
                </span>
              </div>
            </div>
          </el-form>
          
          <div class="edit-company-btn" v-if="!persionDisabled">
            <gj-button type="primary" class="btn" @click="cancelPersion">取消</gj-button>
            <gj-button type="primary" class="btn" @click="confirmPersion" :loading="persionLoading">确定</gj-button>
          </div>
         </div>
        </div>
      </div>
    </template>
    <!-- <template #setMeal>
      <div class="content">
        <personal-center-set-meal></personal-center-set-meal>
      </div>
    </template> -->
  </app-top-tabs>
</template>

<script>
  import PersonalCenterSetMeal from "./personal-center-setMeal";
  import {
    editEmail,
    editRealName,
    getPersonalInfo,
    getQrCodeExpired,
    getQrCodeUrl,
    unbindWx,
    userSaveOrUpdate,
    userCompanyInfo
  } from "../../../../api/personal-center";
  import {isMeaningful, isMeaningless} from "../../../../utils/common";
  import EditPassword from './edit-password';
  import ValidatorPhone from './validator-phone';
  import EditPhone from './edit-phone';
  import store from "../../../../store";
  import {USER_SET_USER_INFO, GET_COMPANY_INFO} from "../../../../store/mutation-types";
  import {mapGetters} from "vuex";
  import {isMeaningfulMixin, responseMixin} from "../../../../minxins";
  

  export default {
    name: "personal-center",
    mixins: [isMeaningfulMixin, responseMixin],
    components: {PersonalCenterSetMeal},
    created() {
      this.getPersonalInfo();
      this.userCompanyInfo()
    },
    data() {
      return {
        editRealName: null,
        editEmail: null,
        editPassword: null,
        editAgainPassword: null,
        personalInfo: {
          userName: null,
          realName: null,
          phone: null,
          email: null,
          roleList: null,
          isMain: false,
          wxHeadImageAddress: null
        },
        flag: {
          realNameFlag: false,
          emailFlag: false,
        },
        loading: {
          name: false,
          phone: false,
          email: false,
          password: false,
          company: false
        },
        // 二维码链接
        qrCodeSrc: null,
        qrCodeLoading: false,
        // 二维码是否已过期
        qrCodeExpired: false,
        // 是否已绑定微信
        boundWx: null,
        // 公司信息
        companyForms: {
          companyName: '',
          persionInfo: [{
            consignee: '',
            consigneeTel: '',
            consigneeAddress: '',
          }]
        },
        storagePersionArr: [{
          companyName: '',
          consignee: '',
          consigneeTel: '',
          consigneeAddress: '',
        }],
        persionLoading: false,
        persionDisabled: true
      }
    },
    computed: {
      ...mapGetters(['userInfo'])
    },
    methods: {
      saveName() {
        if (isMeaningless(this.editRealName)) {
          this.$gjMessage.error('请输入真实姓名');
          return;
        }
        if (this.editRealName.length > 20 || this.editRealName.length < 2) {
          this.$gjMessage.error('真实姓名长度限制2-20个字符');
          return;
        }
        this.loading.name = true;
        editRealName(this.editRealName)
          .then(() => {
            this.$gjMessage.success('修改成功');
            this.flag.realNameFlag = !this.flag.realNameFlag;
            this.personalInfo.realName = this.editRealName;
            store.commit(USER_SET_USER_INFO, {
              ...this.userInfo,
              name: this.editRealName
            });
          }).complete(() => this.loading.name = false)
      },
      saveEmail() {
        this.loading.email = true;
        if (isMeaningless(this.editEmail)) {
          this.$gjMessage.error('请输入邮箱');
          return;
        }
        const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
        if (!reg.test(this.editEmail)) {
          this.$gjMessage.error('请输入正确的邮箱');
          return;
        }
        editEmail(this.editEmail)
          .then(() => {
            this.$gjMessage.success('修改成功');
            this.flag.emailFlag = !this.flag.emailFlag;
            this.personalInfo.email = this._.cloneDeep(this.editEmail);
          }).complete(() => this.loading.email = false)
      },
      replacePwd() {
        this.$gjCreate(EditPassword)
      },
      validatorPhone() {
        // 测试用
        if (this.personalInfo.isMain) {
          const modal = this.$gjCreate(ValidatorPhone, {
            props: {
              phone: this.personalInfo.phone,
              isMain: this.personalInfo.isMain
            },
            on: {
              after: () => {
                this.replacePhone();
                modal.$gjDestroy();
              }
            }
          })
        } else {
          this.replacePhone();
        }
      },
      replacePhone() {
        const modal = this.$gjCreate(EditPhone, {
          props: {
            isMain: this.personalInfo.isMain,
          },
          on: {
            after: () => {
              modal.$gjDestroy();
              this.getPersonalInfo();
            }
          }
        })
      },
      refreshQrCode() {
        this.getQrCodeUrl();
      },
      getQrCodeUrl() {
        this.qrCodeLoading = false;
        getQrCodeUrl(this.personalInfo.userName)
          .then(url => {
            this.qrCodeSrc = url;
            this.qrCodeExpired = false;
          })
          .complete(() => this.qrCodeLoading = false);
      },
      unbindWx() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            content: '确定要解绑微信吗？',
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              unbindWx({
                phone: this.personalInfo.phone,
                username: this.personalInfo.userName,
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.boundWx = false;
                    this.getQrCodeUrl();
                    this.checkBindStatus();
                    this.checkQrCodeExpired();
                    this.$gjMessage.success('解绑成功');
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      getPersonalInfo() {
        getPersonalInfo()
          .then((result) => {
            this.personalInfo.isMain = isMeaningful(result.accountType) && result.accountType === 'MAIN';
            this.personalInfo.userName = result.userName;
            this.personalInfo.email = result.email;
            this.personalInfo.phone = result.phone;
            this.personalInfo.realName = result.name;
            this.personalInfo.roleList = result.roleList || [];
            this.personalInfo.wxHeadImageAddress = result.wxHeadImageAddress;
            this.editRealName = result.name;
            this.editEmail = result.email;
            this.boundWx = result.bindStatus === 'Y';
            if (!this.boundWx) {
              this.getQrCodeUrl();
              this.checkBindStatus();
              this.checkQrCodeExpired();
            }
          })
      },
      checkQrCodeExpired() {
        const checkQrCodeExpiredHandler = setInterval(() => {
          this.getQrCodeUrl(false);
        }, 3 * 1000 * 60);
        this.$on('hook:destroyed', () => {
          clearInterval(checkQrCodeExpiredHandler);
        });
      },
      checkBindStatus() {
        const checkBindHandler = setInterval(() => {
          getPersonalInfo()
            .then(result => {
              this.boundWx = result.bindStatus === 'Y';
              if (this.boundWx) {
                this.personalInfo.wxHeadImageAddress = result.wxHeadImageAddress;
                clearInterval(checkBindHandler);
              }
            })
        }, 5000);
        this.$on('hook:destroyed', () => {
          clearInterval(checkBindHandler);
        });
      },

      userCompanyInfo() {
        return userCompanyInfo().then(res => {
          if (res.isSuccess) {
            if (res.data && res.data.length) {
              this.storagePersionArr = this._.cloneDeep(res.data)
            }
            this.initPersionForms(res.data)
          }
          return res
        })
      },
      initPersionForms(arr) {
        const instance = arr[0]
        if (instance) {
          this.companyForms = {
            companyName: instance.companyName,
            persionInfo: arr
          }
        }
      },
      handEdit() {
        this.persionDisabled = false
      },
      addPersion() {
        if (this.companyForms.persionInfo.length === 20) {
          this.$message.info('数量已到达最大值！')
          return
        }
        this.companyForms.persionInfo.push({
          consignee: '',
          consigneeTel: '',
          consigneeAddress: '',
        })
      },
      reducePersion(index) {
        this.companyForms.persionInfo.splice(index, 1)
      },
      confirmPersion() {
        this.$refs['performs'].validate().then(_ => {
          const o = {}
          const instance = this.companyForms.persionInfo.find(v => {
            if (!o[v.consignee]) {
              o[v.consignee] = v.consignee
            } else {
              return v
            }
          })
          
          if (instance) {
            this.$message.info('禁止提交重复收货人姓名！')
            return
          }

          const sendData = this._.cloneDeep(this.companyForms)
          const arr = sendData.persionInfo.map(v => ({
            ...v,
            companyName: this.companyForms.companyName
          }))
          this.persionLoading = true
          userSaveOrUpdate(arr).then(res => {
            if (res) {
              this.$message.success('操作成功')
              const isRouter = this.$route.params.isRouter
              this.loading.company = true
              this.$store.dispatch(GET_COMPANY_INFO).then(res => {
                this.storagePersionArr = this._.cloneDeep(res.data || [])
                if (res.isSuccess) {
                  this.persionDisabled = true
                  if (isRouter) {
                    this.$router.go(-1)
                  }
                }
              }).complete(_ => {
                this.loading.company = false
              })
              // this.userCompanyInfo().then(res => {
              //   if (res.isSuccess) {
              //     this.$store.commit('user/SET_COMPANY_INFO', res.data || [])
              //     if (isRouter) {
              //       this.$router.go(-1)
              //     }
              //   }
              // })
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          }).complete(_ => {
            this.persionLoading = false
          })
        })
      },
      cancelPersion() {
        this.$refs['performs'].resetFields()
        this.initPersionForms(this._.cloneDeep(this.storagePersionArr))
        this.persionDisabled = true
      }
    }
  }
</script>

<style scoped lang="scss">
  .content {
    padding: 16px 20px;
    font-size: 14px;
    height: calc(100vh - 177px);
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar-track{
      background: #fff;
    }
  }
  .main-account-styl {
    background-color: #3582fb;
    display: inline-block;
    padding: 3px 10px;
    border-radius: 20px;
  }
  .content-detail {
    margin-left: 13px;
  }
  .content-detail > div{
    /*padding-bottom: 20px;*/
    padding: 10px 0;
  }
  .personal-label {
    color: #666;
    display: inline-block;
    width: 70px;
    text-align: right;
    margin-right: 20px;
  }
  .personal-value {
    color: #444;
    display: inline-block;
    margin-right: 16px;
  }
  .name-edit,
  .email-edit {
    display: none;
    cursor: pointer;
  }
  .content-name--hover:hover .name-edit {
    display: inline;
  }
  .content-email--hover:hover .email-edit {
    display: inline;
  }
  .content-line {
    height: 1px;
    background-color: #e8e8e8;
  }
  .personal-desc {
    color: #888;
    display: inline-block;
    margin-right: 16px;
    font-size: 12px;
  }
  .edit-unfold {
    text-align: right;
    display: inline-block;
  }
  .ml80 {
    margin-left: 80px!important;
  }
  .v-code {
    margin-left: 8px;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .unbind-title {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }
  .expired-qrcode {
    position: absolute;
    width: 146px;
    height: 142px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
    border: 1px solid rgb(222, 222, 222);
    z-index: 1;
  }
  .expired-qrcode-tip {
    font-size: 13px;
    color: #666;
    margin-bottom: 10px;
  }
  .edit-company-info_icon {
    color: #3582fb;
    font-size: 18px;
    margin-left: 15px;
    cursor: pointer;
  }
  .edit-company-info_item {
    padding: 10px 8px;
    box-sizing: border-box;
    background: #EEEFF0;
    margin-top: 20px;
  }
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
  .edit-company-info_item-inner {
    display: flex;
    align-items: center;
  }
  .edit-company-info_add {
    cursor: pointer;
    color: #3582fb;
    font-size: 20px;
    vertical-align: middle;
    &:hover {
      opacity: .8;
    }
  }
  .edit-company-btn {
    background-color: #fff;
    z-index: 1;
    box-shadow: 0px -2px 0px 0px rgba(0,0,0,0.1);
    padding: 20px 0;
    text-align: center;
    margin-top: 20px;
    .btn {
      width: 100px;
    }
  }
  .personal-center{
    height:100%; 
    background-color: #fff;
  }
</style>
